var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimelineWelcome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#380116",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 66h29l9-15h45l10 15h32c9 0 14 6 14 14v70c0 9-5 14-14 14H37c-9 0-14-5-14-14V80c0-8 5-14 14-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 87h44m62 0h43M25 144h45m60 0h44",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 115,
    r: 36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 115,
    r: 28,
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 131c-5-5-18-13-18-21 0-10 13-13 18-4 5-9 18-6 18 4 0 8-13 16-18 21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 66v-8h18v8M83 59h29M145 77h16v10h-16Z",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 81,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 151h13M47 156h13M145 43v-7m-9 9-5-5m23 5 5-5",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 44c-3-3-11-8-11-13 0-6 8-8 11-3 3-5 11-3 11 3 0 5-8 10-11 13Z",
    strokeWidth: 1.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineWelcome);
export default __webpack_public_path__ + "static/media/timeline-welcome.833f41450fb14ff19ffabfa11588a4b7.svg";
export { ForwardRef as ReactComponent };